//
//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from "../../../utilities/directives";
export default {
  name: "SfChevron",
  directives: {
    focus,
  },
};
